<template>
    <card :noFooterLine="true" class="report-card" :class="cardType">

        <div slot="image"  class="report-card-image" :style="`background-image:url(${image})`">
            <!-- <n-button type="success" class="action-btn" size="sm" @click.native="cardClick">
                <i slot="label" class="now-ui-icons gestures_tap-01"></i> Register Now
            </n-button> -->
        </div>

        <div class="report-card-header">
            <h6 class="card-category" v-if="category">{{ category }}</h6>
            <h6 class="card-category" v-else>&nbsp;</h6>
            <h4 v-if="title" class="card-title">{{ title }}</h4>
        </div>

        <div class="report-card-body">
            <p class="card-text">{{ description }}</p>
        </div>

        <div slot="footer" v-if="showFooter">
            <p class="card-text status-btns text-center">
                <el-tooltip content="Download Report" :open-delay="100" placement="bottom">
                    <n-button :type="btnType" simple block size="sm" @click.native="downloadFile">{{ btnText }}</n-button>
                </el-tooltip> 
            </p>
        </div>
    </card>
</template>

<script>
import { Card } from 'src/components'
import {Tooltip} from 'element-ui'
import { mapGetters } from "vuex";

export default {
    name: 'PreviewCard',
    components: {
        Card,
        [Tooltip.name]: Tooltip,
    },
    props: {
        image: String,
        title: String,
        description: String,
        category: String,
        slug: String,
        showFooter: {
            type: Boolean,
            default: false,
        },
        cardType: String,
        link: String,
        btnText: {
            type: String,
            default: 'Download',
        },
        btnType: {
            type: String,
            default: 'success',
        }
    },
    computed: {
        ...mapGetters({
            authTokens: 'getAuthTokens'
        }),
        headers(){
            let {token, refreshtoken} = this.authTokens
            return {token, refreshtoken};
        }
    },
    methods:{
        downloadFile(){
            fetch(`${process.env.VUE_APP_BASE_URL}${this.link}`, {
                method: 'GET',
                headers: new Headers(this.headers)
            })
            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = "report.xlsx";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();  //afterwards we remove the element again         
            });
        }
    }
}
</script>

<style lang="scss">

/* Using plain CSS */
@media (max-width: 768px) {
    .report-card.long{
        flex-direction: column !important;

        .card-body::after{
            display: none !important;
        }

        .action-btn{
            right: 0px !important;
            bottom: 160px !important;
            font-size: 14px !important;
            padding: 5px 10px !important;
        }
    }
}

.report-card{
    
    &.long{
        display: flex;
        flex-direction: row;
        cursor: pointer;
        border-radius: 0.1875rem;
        overflow: hidden;

        .card-image{
            flex: 1;
            transition: all ease-in-out 0.3s;

            .report-card-image{
                position: static;
                .action-btn{
                    z-index: 3;
                    right: 10px;
                    bottom: 0px;

                    font-size: 16px;
                    border-radius: 0.1875rem;
                    padding: 10px 15px;
                }
            }
        }

        .card-header,
        .card-body,
        .card-footer{
            flex: 2;
        }

        .card-body{
            padding: 15px;
            padding-left: 30px;
            position: relative;
            transition: all ease-in-out 0.3s;
            z-index: 2;

            &::after{
                content: '';
                position: absolute;
                height: 100%;
                width: 50px;
                background-image: linear-gradient(to right, rgba(255, 0, 0, 0), rgba(255, 255, 255, 1) 50%);
                top: 0;
                left: -50px;
                transition: all ease-in-out 0.3s;
                z-index: 1;
            }
        }

        &:hover > .card-body{
            padding-left: 30px;
        }

        &:hover > .card-body::after{
            // flex: 1.2;
            left: -30px;
        }

        // &:hover > .card-image{
        //     flex: 1.2;
        // }

    }

    .report-card-header{
        .card-title{
            margin-top: 0px;
            margin-bottom: 5px;
        }
    }

    .card-footer .status-btns .btn{
        margin-right: 3px;
    }

    .card-header .card-title{
        margin-top: 5px;
        margin-bottom: 0.5rem;
    }

    .category, .card-category{
        margin-bottom: 0.2em;
    }

    .card-body{
        padding: 5px 15px 15px 15px;
    }

    .description, 
    .card-description, 
    .footer-big p, 
    .footer .stats{
        color: #353a3e;
    }

    .card-image{
        .report-card-image{
            height: 200px;
            position: relative;
            text-align: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            box-shadow: inset -1px -5px 5px -3px rgba(0, 0, 0, 0.16);

            .action-btn{
                right: -20px;
                bottom: -25px;
                position: absolute;
                box-shadow: 0px 2px 3px rgba(0,0,0,0.16);
            }

            .card-img-top{
                width: auto;
                height: 200px;
                margin: 0 auto;
                text-align: center;
            }
        }
    }

} 

</style>
